import Vue from 'vue';
import * as types from '../mutation-types';
import cookie from 'services/cookie';

const state = {
  sidebar: {
    opened: false,
    withoutAnimation: false,
  },
  config: {
    googleMaps: {
      // parkec.app@gmail.com
      apiKey: 'AIzaSyDdpuyOx_vy8VdOQ4OD4AFNYqnCBy8Is6g',
    },
    windowMatchSizeLg: '(min-width: 992px)',
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd',
    },
    api: {
      get host () {
        return cookie.get('apiHost') || 'https://api.parkec.fletrix.hk';
      },
      base: '/api/v1',
      sso: '/sso',
    },
    debug: !!cookie.get('debug'),
    allowedRoles: ['admin', 'landlord'],
  },
  isLoading: true,
  initialized: false,
  user: null,
  profile: null,
  notifications: [],
};

const mutations = {
  [types.CLOSE_MENU] (state) {
    if (document.documentElement.clientWidth < 992) {
      state.sidebar.opened = false;
    }
  },
  [types.TOGGLE_SIDEBAR] (state, opened) {
    state.sidebar.opened = opened;
  },
  [types.TOGGLE_WITHOUT_ANIMATION] (state, value) {
    state.sidebar.withoutAnimation = value;
  },
  setLoading (state, isLoading) {
    state.isLoading = isLoading;
  },
  setUser (state, {user, profile}) {
    state.user = user;
    state.profile = profile;
  },
  setNotifications (state, value) {
    state.notifications = value || {docs: [], total: 0};
  },
};

const actions = {
  closeMenu ({commit}) {
    commit(types.CLOSE_MENU);
  },
  toggleSidebar ({commit}, opened) {
    commit(types.TOGGLE_SIDEBAR, opened);
  },
  isToggleWithoutAnimation ({commit}, value) {
    commit(types.TOGGLE_WITHOUT_ANIMATION, value);
  },
  async updateNotifications ({commit, getters}) {
    if (getters.user) {
      commit('setNotifications', (await Vue.http.get('user/me/notification', {
        params: {
          limit: 5,
          sort: window.RISON.encode({created_at: -1}),
          filter: window.RISON.encode({read: null}),
        },
      })).body);
    }
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js